import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CultureTreeSelect from '@client/components/ui/select/CultureTreeSelect';

const CultureStepContent = ({
  step,
  value,
  selectionLabels,
  onChange,
  onForceRevalidation,
}) => {
  const { t } = useTranslation('treatment-search');

  const handleChange = (selectedValues, selectedNodes) => {
    const values = Array.isArray(selectedValues) ? selectedValues : [];
    const nodes = Array.isArray(selectedNodes) ? selectedNodes : [];

    const transformedItems = nodes.filter(Boolean).map((node) => ({
      value: node.value || node.id,
      label: node.label || node.french_name || node.name || String(node.value || node.id),
    }));

    onChange(values, transformedItems);
  };

  // Filter to only show cultures enabled for multi-choice processing
  const filterParams = useMemo(() => ({
    show_in_customer_filter_multi_processing: true,
  }), []);

  return (
    <div className="w-full">
      <CultureTreeSelect
        labelField="french_name"
        isMulti={true}
        label={t(step.placeholder)}
        placeholder={t(step.placeholder)}
        value={value}
        onChange={handleChange}
        checkStrictly={false}
        treeCheckable={true}
        showCheckedStrategy="SHOW_CHILD"
        languageFields={step?.languageConfig?.fields}
        languageLabels={step?.languageConfig?.labels}
        defaultLanguage={step?.languageConfig?.defaultLanguage || 'fr'}
        showLanguageSelector={!!step?.languageConfig}
        onLanguageChange={onForceRevalidation}
        filterParams={filterParams}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default CultureStepContent;
